<ul class="guest-flow-player-list">
  @for (item of items; track item.id) {
    <li>
      @if (clickable) {
        <button type="button" class="guest-flow-player-row" [class.is-muted]="item.muted" (click)="itemClick.emit(item)">
          <ng-container *ngTemplateOutlet="rowContent; context: {$implicit: item}"></ng-container>
          @if (showChevron) {
            <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
          }
        </button>
      } @else {
        <div class="guest-flow-player-row" [class.is-muted]="item.muted">
          <ng-container *ngTemplateOutlet="rowContent; context: {$implicit: item}"></ng-container>
        </div>
      }
    </li>
  }
</ul>

<ng-template #rowContent let-item>
  <span class="guest-flow-avatar" aria-hidden="true">{{ item.initial }}</span>
  <span class="guest-flow-player-copy">
    <strong>{{ item.name }}</strong>
    <small>{{ item.description }}</small>
  </span>
</ng-template>
